import axios from "axios";

export const api = axios.create({
  // baseURL: "https://controletransporte.dcisuporte.com.br"
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "cod_cliente": `${process.env.REACT_APP_COD_CLIENTE}`
  }
});